import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuChecklistComponent } from './au-checklist.component';
import { ChecklistInputComponent } from './checklist-input/checklist-input.component';
import { ChecklistItemComponent } from './checklist-item/checklist-item.component';
import { ChecklistProgressBarComponent } from './checklist-progress-bar/checklist-progress-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxTolgeeModule } from '@tolgee/ngx';

@NgModule({
	imports: [
		CommonModule,
		MatIconModule,
		ReactiveFormsModule,
		NgxTolgeeModule,
		AuChecklistComponent,
		ChecklistInputComponent,
		ChecklistItemComponent,
		ChecklistProgressBarComponent,
	],
	exports: [AuChecklistComponent],
})
export class AuChecklistModule {}
